// extracted by mini-css-extract-plugin
module.exports = {"searchRoot":"SelectTag-styles_searchRoot__301Dy","searchInput":"SelectTag-styles_searchInput__3SfMG"};